import React, { Component } from "react";
import { safeDeepGet } from 'iotera-base/json'
import { isNone } from 'iotera-base/object'
import { withRouter } from "react-router";
import paymentImage from './payment.svg'
import './billing.css'
import { RedirectToApp } from "../../routes/routes";

class BillingExpired extends Component {
  render() {
    const stateLocation = safeDeepGet(this, ['props', 'location', 'state'])
    if (isNone(stateLocation)) {
      return <RedirectToApp />
    }
    const isTenant = safeDeepGet(stateLocation, ['isTenant'])
    let renderView = null
    if (isTenant) {
      renderView =
        // optional 1
        <div className="center-vh-2">
          <div className="io-container">
            <div className="io-row justify-content-center">
              <img src={paymentImage} alt="Payment" height={308} width={548} />
            </div>
            <div className="io-row justify-content-center font-weight-bolder pt-5">
              Billing expired. Complete the payment process to feel benefits of our platform. Please contact: support@iotera.io
            </div>
          </div>
        </div>
      // optional 2
      // <div className="center-vh-1">
      //   <div className="card">
      //     <div className="card-header font-weight-bolder">
      //       Billing Expired
      //       </div>
      //     <div className="card-body">
      //       <div className="io-container d-flex">
      //         <div className="io-row">
      //           <div className="io-col">
      //             <img src={paymentImage} alt="Payment" height="100%" width="100%" />
      //           </div>
      //         </div>
      //         <div className="io-col">
      //           <div>
      //              Billing expired. Please complete the payment process to feel benefits of our platform
      //             </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    }
    else {
      renderView =
        // option 1
        <div className="center-vh-2">
          <div className="io-container">
            <div className="io-row justify-content-center">
              <img src={paymentImage} alt="Payment" height={308} width={548} />
            </div>
            <div className="io-row justify-content-center font-weight-bolder pt-5">
              Billing expired. Please contact your tenant to complete payment process
            </div>
          </div>
        </div>
      // option 2
      // <div className="center-vh-1">
      //   <div className="card">
      //     <div className="card-header font-weight-bolder">
      //       Billing Expired
      //     </div>
      //     <div className="card-body">
      //       <div className="io-container d-flex">
      //         <div className="io-row">
      //           <div className="io-col">
      //             <img src={paymentImage} alt="Payment" height="100%" width="100%" />
      //           </div>
      //         </div>
      //         <div className="io-col">
      //           <div>
      //             Billing expired. Please contact your tenant to complete payment process
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    }
    return renderView
  }
}

export default withRouter(BillingExpired)